import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import * as productActions from "../product.actions";
import { getProductCategories } from "../../product-category/product-category.selectors";

import Table from "../../common/components/Table";
import { Localize } from "../../../locale/localization";
import { sortTableAndHead } from "../../../utils/content-utils";
import TableHeader from "../../common/components/TableHeader";

class ProductListContainer extends Component {
  state = {
    sortedData: [],
    tableHead: [
      { name: "name", uiName: Localize("package") },
      { name: "description", uiName: Localize("description") }
    ]
  };

  componentWillMount() {
    this.updateSortData(this.props.products);
  }

  componentWillReceiveProps(nextProps) {
    this.updateSortData(nextProps.products);
  }

  updateSortData = content => {
    this.setState(
      Object.assign({}, this.state, {
        sortedData: content ? content : []
      })
    );
  };

  sortTable = headItem => {
    const sorted = sortTableAndHead(headItem, this.state.tableHead, this.state.sortedData);

    this.setState(
      Object.assign({}, this.state, {
        sortedData: sorted.data,
        tableHead: sorted.head
      })
    );
  };

  componentWillMount = () => {
    const { getProducts } = this.props;
    getProducts(true);
  };

  renderProductRow = product => {
    const { _id, name, description } = product;

    return (
      <tr key={_id}>
        <td>{name}</td>
        <td>{description}</td>
        <td>
          <NavLink to={`/admin/product-categories/edit/${_id}`}>{Localize("action.edit")}</NavLink>
        </td>
      </tr>
    );
  };

  renderTableHeader = () => {
    return (
      <TableHeader
        items={this.state.tableHead}
        onSort={this.sortTable}
        sortable={this.state.sortedData.length > 1}
      />
    );
  };

  render() {
    const products = this.state.sortedData;
    return (
      <div>
        {products && products.length > 0 ? (
          <Table
            items={products}
            renderHeader={this.renderTableHeader}
            renderItem={this.renderProductRow}
          />
        ) : (
          <p>{Localize("package.empty")}</p>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const products = getProductCategories(state).filter(category => !category.private);
  return {
    products
  };
};

const ConnectedProductListContainer = connect(mapStateToProps, Object.assign({}, productActions))(
  ProductListContainer
);

export default ConnectedProductListContainer;



// WEBPACK FOOTER //
// ./src/modules/product/components/ProductListContainer.js